/**
 * Validates an email address format
 * @param email - The email to validate
 * @returns true if valid, false otherwise
 */
export const isValidEmail = (email: string): boolean => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}
